/**
 * ─── Audio mode switch ────────────────────────────────────────────────────────
 *
 * Single source of truth for which audio backend the site uses.
 *
 *   "generative" → the Tone.js GenerativeAudioEngine (default).
 *   "mp3"        → the legacy MP3 background-track player (kept as a fallback).
 *   "off"        → no audio of any kind starts.
 *
 * The MP3 backend is intentionally preserved so the change is reversible: flip
 * DEFAULT_AUDIO_MODE to AUDIO_MODES.MP3 (or .OFF) to roll back without deleting
 * code or assets. Read by BackgroundAudioProvider (which owns the audio UI
 * contract) and audioController (which owns the generative engine singleton).
 * ──────────────────────────────────────────────────────────────────────────── */

export const AUDIO_MODES = {
    GENERATIVE: 'generative',
    MP3: 'mp3',
    OFF: 'off',
};

// Production default. Switch to AUDIO_MODES.MP3 to restore the old background
// tracks, or AUDIO_MODES.OFF to silence the site entirely.
export const DEFAULT_AUDIO_MODE = AUDIO_MODES.GENERATIVE;

// Diagnostic `[audio]` console logging for the engine + controller. Off by
// default; flip to true to trace startup/interaction wiring. (Errors are always
// logged regardless of this flag.)
export const AUDIO_DEBUG = false;
